var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("layout-card", {
    staticClass: "card-task",
    attrs: {
      error: _vm.error,
      isCustomizable: _vm.settings.isCustomizable,
      loading: _vm.loading
    },
    on: {
      "hide-card": function($event) {
        return _vm.$emit("hide-card", "task")
      },
      "refresh-card": function($event) {
        return _vm.fetchCard("task", {}, true)
      },
      "edit-card": _vm.toggleSettingsForm
    },
    scopedSlots: _vm._u(
      [
        {
          key: "title",
          fn: function() {
            return [_vm._v("\n        " + _vm._s(_vm.name) + "\n    ")]
          },
          proxy: true
        },
        {
          key: "actions",
          fn: function() {
            return [
              _c("CompassIconButton", {
                attrs: { icon: "plus" },
                on: { click: _vm.onCreateTask }
              })
            ]
          },
          proxy: true
        },
        _vm.cardData && Object.keys(_vm.cardData).length > 0
          ? {
              key: "content",
              fn: function() {
                return [
                  _c(
                    "el-tabs",
                    {
                      staticClass: "flex-column wp-10 hp-10 task-tab",
                      attrs: { value: "current" }
                    },
                    [
                      _c(
                        "el-tab-pane",
                        {
                          staticClass: "flex-column hp-10 pr-2",
                          attrs: { name: "late" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "label",
                                fn: function() {
                                  return [
                                    _c(
                                      "span",
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "semibold" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$l10n.__("En retard"))
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("el-badge", {
                                          attrs: {
                                            value: _vm.countTasks(_vm.lateTasks)
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            870911360
                          )
                        },
                        [
                          _vm._v(" "),
                          _vm.lateTasks.length > 0
                            ? _c("div", { staticClass: "aright mb-2" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "link aright",
                                    attrs: { href: _vm.cardData.late.link }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$l10n.__(
                                          "Voir toutes les tâches en retard"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.lateTasks.length > 0
                            ? [
                                _c(
                                  "ul",
                                  { staticClass: "task-list" },
                                  _vm._l(_vm.lateTasks, function(task) {
                                    return _c(
                                      "li",
                                      {
                                        key: task.id,
                                        staticClass: "mb-1 br",
                                        on: {
                                          click: function($event) {
                                            return _vm.taskDetail(task)
                                          }
                                        }
                                      },
                                      [
                                        _c("task", {
                                          attrs: { task: task, type: "late" }
                                        })
                                      ],
                                      1
                                    )
                                  }),
                                  0
                                )
                              ]
                            : [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "my-0 mx-auto flex-column hp-10 ai-center jc-center",
                                    staticStyle: { width: "170px" }
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src:
                                          "/ressources/logged/img/dashboard/dashboard-task.svg",
                                        alt: "",
                                        width: "120"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "mt-3 gray-60 acenter" },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$l10n.__(
                                                "Vous n'avez aucune tâche en retard"
                                              )
                                            ) +
                                            "\n                        "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "el-tab-pane",
                        {
                          staticClass: "flex-column hp-10 pr-2",
                          attrs: { name: "current" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "label",
                                fn: function() {
                                  return [
                                    _c(
                                      "span",
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "semibold" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$l10n.__("À faire"))
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("el-badge", {
                                          attrs: {
                                            value: _vm.countTasks(
                                              _vm.currentTasks
                                            )
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            3824867571
                          )
                        },
                        [
                          _vm._v(" "),
                          _vm.currentTasks.length > 0
                            ? _c("div", { staticClass: "aright mb-2" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "link aright",
                                    attrs: { href: _vm.cardData.current.link }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$l10n.__(
                                          "Voir toutes les tâches à faire"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.currentTasks.length > 0
                            ? [
                                _c(
                                  "ul",
                                  { staticClass: "task-list" },
                                  _vm._l(_vm.currentTasks, function(task) {
                                    return _c(
                                      "li",
                                      {
                                        key: task.id,
                                        staticClass: "mb-1 br",
                                        on: {
                                          click: function($event) {
                                            return _vm.taskDetail(task)
                                          }
                                        }
                                      },
                                      [
                                        _c("task", {
                                          attrs: { task: task, type: "current" }
                                        })
                                      ],
                                      1
                                    )
                                  }),
                                  0
                                )
                              ]
                            : [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "my-0 mx-auto flex-column hp-10 ai-center jc-center",
                                    staticStyle: { width: "170px" }
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src:
                                          "/ressources/logged/img/dashboard/dashboard-task.svg",
                                        alt: "",
                                        width: "120"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "mt-3 gray-60 acenter" },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$l10n.__(
                                                "Vous n'avez aucune tâche à faire"
                                              )
                                            ) +
                                            "\n                        "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "el-tab-pane",
                        {
                          staticClass: "flex-column hp-10 pr-2",
                          attrs: { name: "incoming" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "label",
                                fn: function() {
                                  return [
                                    _c(
                                      "span",
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "semibold" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$l10n.__("À venir"))
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("el-badge", {
                                          attrs: {
                                            value: _vm.countTasks(
                                              _vm.incomingTasks
                                            )
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            900467171
                          )
                        },
                        [
                          _vm._v(" "),
                          _vm.incomingTasks.length > 0
                            ? _c("div", { staticClass: "aright mb-2" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "link aright",
                                    attrs: { href: _vm.cardData.incoming.link }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$l10n.__(
                                          "Voir toutes les tâches à venir"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.incomingTasks.length > 0
                            ? [
                                _c(
                                  "ul",
                                  { staticClass: "task-list" },
                                  _vm._l(_vm.incomingTasks, function(task) {
                                    return _c(
                                      "li",
                                      {
                                        key: task.id,
                                        staticClass: "mb-1 br",
                                        on: {
                                          click: function($event) {
                                            return _vm.taskDetail(task)
                                          }
                                        }
                                      },
                                      [
                                        _c("task", {
                                          attrs: {
                                            task: task,
                                            type: "incoming"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  }),
                                  0
                                )
                              ]
                            : [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "my-0 mx-auto flex-column hp-10 ai-center jc-center",
                                    staticStyle: { width: "170px" }
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src:
                                          "/ressources/logged/img/dashboard/dashboard-task.svg",
                                        alt: "",
                                        width: "120"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "mt-3 gray-60 acenter" },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$l10n.__(
                                                "Vous n'avez aucune tâche à venir"
                                              )
                                            ) +
                                            "\n                        "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "el-tab-pane",
                        {
                          staticClass: "flex-column hp-10 pr-2",
                          attrs: { name: "completed" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "label",
                                fn: function() {
                                  return [
                                    _c(
                                      "span",
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "semibold" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$l10n.__("Terminées"))
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("el-badge", {
                                          attrs: {
                                            value: _vm.countTasks(
                                              _vm.completedTasks
                                            )
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            1790235128
                          )
                        },
                        [
                          _vm._v(" "),
                          _vm.completedTasks.length > 0
                            ? _c("div", { staticClass: "aright mb-2" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "link aright",
                                    attrs: { href: _vm.cardData.completed.link }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$l10n.__(
                                          "Voir toutes les tâches terminées"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.completedTasks.length > 0
                            ? [
                                _c(
                                  "ul",
                                  { staticClass: "task-list" },
                                  _vm._l(_vm.completedTasks, function(task) {
                                    return _c(
                                      "li",
                                      {
                                        key: task.id,
                                        staticClass: "mb-1 br",
                                        on: {
                                          click: function($event) {
                                            return _vm.taskDetail(task)
                                          }
                                        }
                                      },
                                      [
                                        _c("task", {
                                          attrs: {
                                            task: task,
                                            type: "completed"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  }),
                                  0
                                )
                              ]
                            : [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "my-0 mx-auto flex-column hp-10 ai-center jc-center",
                                    staticStyle: { width: "170px" }
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src:
                                          "/ressources/logged/img/dashboard/dashboard-task.svg",
                                        alt: "",
                                        width: "120"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "mt-3 gray-60 acenter" },
                                      [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$l10n.__(
                                                "Vous n'avez aucune tâche terminée"
                                              )
                                            ) +
                                            "\n                        "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "portal",
                    { attrs: { to: "dashboardSettingsForm" } },
                    [
                      _vm.showSettingsForm
                        ? _c("card-setting-overlay", {
                            attrs: {
                              formName: _vm.settingsFormName,
                              cardCustomSettings: _vm.customSettings,
                              cardName: _vm.type
                            },
                            on: {
                              fetched: _vm.fetchCard,
                              "close-form": _vm.toggleSettingsForm,
                              "custom-settings-saved": function($event) {
                                return _vm.fetchCard(_vm.type, {}, true)
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          : null
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }